import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './pages/Home.vue';
import Post from './pages/Post.vue';
import Posts from './pages/Posts.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            props: route => ({ initialPage: parseInt(route.query.page ?? 1) })
        },
        {
            path: '/categoria/:slug',
            name: 'posts',
            component: Posts,
            props: route => ({ initialPage: parseInt(route.query.page ?? 1) })
        },
        {
            path: '/comunicado/:slug',
            name: 'post',
            component: Post
        },
        {
            path: '/preview/:slug/:token',
            name: 'preview',
            component: Post,
            props: route => ({ preview: true, slug: route.params.slug, token: route.params.token })
        },
        {
            path: '/post/:slug',
            name: 'posts-old',
            component: Post
        },
        {
            path: "*",
            component: Home
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        // savedPosition is only available for popstate navigations.
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                // create an Observer instance to listen to height changes on an object
                const resizeObserver = new ResizeObserver(entries => {
                    // Check if the height is enough to scroll to that point
                    if (entries[0].target.clientHeight >= savedPosition.y + screen.height) {
                        // Then resolve to trigger the scroll and disconnect the observer
                        resolve(savedPosition)
                        resizeObserver.disconnect();
                    }
                });
                // Start observing the DOM node
                resizeObserver.observe(document.body);
            });
        }

        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        if (to.params.savePosition) return {}

        // scroll to anchor by returning the selector
        if (to.hash) {
            let position = { selector: to.hash }

            // specify offset of the element
            // if (to.hash === '#anchor2') {
            //   position.offset = { y: 100 }
            // }
            return position
        }

        // scroll to top by default
        return { x: 0, y: 0 }
    }
});

export default router;